import { render, staticRenderFns } from "./skinnyPagination.vue?vue&type=template&id=180156f4&scoped=true"
import script from "./skinnyPagination.vue?vue&type=script&lang=js"
export * from "./skinnyPagination.vue?vue&type=script&lang=js"
import style0 from "./skinnyPagination.vue?vue&type=style&index=0&id=180156f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180156f4",
  null
  
)

export default component.exports